module.exports = __webpack_public_path__ + "static/media/Rec-3-01.b0ee0ed3.webp";